import { render } from "./DashboardProductScans.vue?vue&type=template&id=97b6cd00"
import script from "./DashboardProductScans.vue?vue&type=script&lang=js"
export * from "./DashboardProductScans.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__